/* eslint-disable*/
define('page/detail/detail-zhimai', [
    'jquery',
    'log',
    'common/util'
], ($,log, util) => {
    function getImgUrl(url, w, h) {
        return `${url}?imageView/4/w/${w}/h/${h}`
    }

    function getImageBooks(cb) {
        $.ajax({
            type: 'GET',
            url: '/lurker/v1/detail/imagebook',
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            },
            crossDomain:true,
            data: {
                cid: RRC.car_encrypt_id
            },
            success(res) {
                if (util.checkLurkerRes(res)) return;
                if (res.status !== 0 || res.data === '' || res.data.imagesBooks === "" || res.data.imagesBooks === null || res.data.imagesBooks.length === 0) {
                    cb();
                    return
                }
                // 头图数组
                const imagesBooks = res.data.imagesBooks;
                let topBigImages = [];
                let detailImages = [{
                    title:'车身外观',
                    des:'车况优秀，性能部件正常使用，经检测，外观及车身结构无重大撞击',
                    images: []
                },{
                    title:'车辆内饰',
                    des:'车内部件功能正常使用，内饰、座椅磨损程度正常，座椅底部、安全带根部等无水泡痕迹',
                    images: []
                },{
                    title:'仪器检测',
                    images: []
                }];
                imagesBooks.forEach(book=>{
                    topBigImages = topBigImages.concat(book.images);
                    if(book.title === '外观')  detailImages[0].images = book.images;
                    if(book.title === '内饰')  detailImages[1].images = book.images;
                    if(book.title === '检测细节')  detailImages[2].images = book.images;
                });
                Vue.prototype.getImgUrl = getImgUrl;
                initTopBigImages(topBigImages,res.data.hasWhole);
                initThumbImages(topBigImages);
                initDetailImages(detailImages,topBigImages);
                initSlideImages(topBigImages);
                initCarousel(topBigImages);
                cb();
            },
            error() {
                cb();
            },
        });
    }

    //头图初始化
    function initTopBigImages(topBigImages, hasWhole) {
        Vue.component('app', {
            template: `<ul class="slides gallery-img">
                <li v-for="item,index in x" >
                    <div class="recommend-img-container" v-if="index === 0">
                        <div class="info-recommend"> 
                            <div class="pic-count"> 
                                <img class="pic-number" src="/dist/images/detail-version3-picCount-c3a14197.png">
                                <span class="current-index"></span>
                                <span class="all-number"></span>
                            </div> 
                        </div>
                        <a :href="'/panorama/'+car_encrypt_id" target="_blank" v-if="hasWhole">
                            <div class="pic-d-img zhimai-quanjing" rrc-page-module rrc-event-display="basicinformation-carimage-panorama_display">
                                <img src="/dist/images/quanjing-zhimai-1e18d1e0.png" alt="" @click="log">
                            </div>
                        </a>
                        <img class="main-pic" src="/dist/images/loading-290f1001.png" :data-src="getImgUrl(item.imgUrl,600,400)" :data-start="index" rrc-event-name="image"/>
                    </div>
                    <div class="recommend-img-container" v-else>
                        <div class="car-detail">
                            <div class="top-title-desc" v-if="item.imgageName">
                                 <p class="title">{{item.imgageName}}</p>
                                 <p class="desc" v-if="item.desc">:&nbsp;&nbsp;&nbsp;{{item.desc}}</p>
                            </div>
                            <div class="photo-number">
                                <img class="pic-number" src="/dist/images/detail-version3-picCount-c3a14197.png">
                                <span class="current-index"></span>
                                <span class="all-number"></span>
                            </div>                                            
                        </div>
                        <img class="main-pic" src="/dist/images/loading-290f1001.png" :data-src="getImgUrl(item.imgUrl,600,400)" :data-start="index" rrc-event-name="image"/>
                    </div>
                </li>
            </ul>`,
            data() {
                return {
                    x: topBigImages,
                    hasWhole: hasWhole,
                    car_encrypt_id:RRC.car_encrypt_id
                };
            },
            methods: {
                log() {
                    log.push(['_trackEvent', 'car-detail_basicinformation-carimage-panorama_click','','','','']);
                }
            }
        });
        new Vue({
            el: '.gallery-img',
            template: '<app/>'
        })
    }

    // 头图下小图初始化
    function initThumbImages(thumbImages) {
        Vue.component('app', {
            template: `<div class="thumb">
                    <ul>
                        <li class="clk" v-for="item,index in datas" rrc-event-name="basicinformation-carimage-size2_click">
                        <a>
                            <img :src="getImgUrl(item.imgUrl,122,81)" :data-src="getImgUrl(item.imgUrl,122,81)" :data-start="index" rrc-event-name="image"/>
                        </a>
                    </li>
                    </ul>
            </div>`,
            data() {
                return {
                    datas: thumbImages
                };
            }
        });
        new Vue({
            el: '.thumb',
            template: '<app/>'
        });
    }

    // 中间图集初始化
    function initDetailImages(detailImages,topBigImages) {
        Vue.component('createQiniuImage',{
            props: {
                w: {
                    type: Number,
                    default: 1400
                },
                h: {
                    type: Number,
                    default: 960
                },
                showDesc: {
                    type: Boolean,
                    default: false
                },
                showMore: {
                    type: Boolean,
                    default: false
                },
                image: Object
            },
            computed: {
                dataStart() {
                    let result = -1;
                    if (topBigImages && topBigImages.length !== 0) {
                        topBigImages.forEach((image, index)=>{
                            if(image.imgId  === this.image.imgId) {
                                result = index;
                            }
                        })
                    }
                    return result
                }
            },
            template:`
                <div>
                    <div class="content" v-if="showDesc"> 
                        <span class="title">{{image.imgageName}}</span> 
                        <span class="desc">{{image.des}}</span> 
                    </div> 
                    <div class="text-and-img"
                         data-start="0"
                         data-flag="find-more"
                         v-if="showMore">
                        <label>查看更多</label>
                    </div>
                    <img class="img-lazy" 
                    rrc-page-module="true" 
                    rrc-event-display="descriptionimages_display" 
                    rrc-event-name="descriptionimages_click" 
                    :rrc-event-expand-tag_value="image.imgageName" 
                    :data-src="getImgUrl(image.imgUrl,w,h)"
                    :data-start="dataStart"
                    style="position: absolute; display: block; opacity: 1;"
                     />
                </div>
            `
        });
        Vue.component('app', {
            template: `<div class="zhimai">
                    <div class="detail-car-appearance" v-for="item,index in datas">
                        <div class="detail-car-appearance-title">
                            <span class="zhimai-title">{{item.title}}</span><span class="zhimai-subtitle">{{item.des}}</span>
                        </div>
                        <div class="detail-car-appearance-content-photo" v-if="index < 2">
                            <div class="loading">
                                <createQiniuImage :image="item.images[getIndex(index,names[index][0])]" :w="568" :h="392"></createQiniuImage>
                            </div>
                            <div class="loading excursion float-to-right">
                                <createQiniuImage :image="item.images[getIndex(index,names[index][1])]" :w="568" :h="392"></createQiniuImage>
                            </div>
                            <div class="loading">
                                <createQiniuImage :image="item.images[getIndex(index,names[index][2])]" :w="568" :h="392"></createQiniuImage>
                            </div>
                            <div class="loading excursion float-to-right">
                                <createQiniuImage :image="item.images[getIndex(index,names[index][3])]" :w="568" :h="392"></createQiniuImage>
                            </div>
                            <div class="loading-small-photo"> 
                                <createQiniuImage :image="item.images[getIndex(index,names[index][4])]" :w="275" :h="204"></createQiniuImage>
                            </div>
                            <div class="loading-small-photo excursion"> 
                                <createQiniuImage :image="item.images[getIndex(index,names[index][5])]" :w="275" :h="204"></createQiniuImage>
                            </div>
                            <div class="loading-small-photo excursion"> 
                                <createQiniuImage :image="item.images[getIndex(index,names[index][6])]" :w="275" :h="204"></createQiniuImage>
                            </div>
                            <div class="loading-small-photo excursion excursion-last"> 
                                <createQiniuImage :show-more="true" :image="item.images[getIndex(index,names[index][7])]" :w="275" :h="204"></createQiniuImage>
                            </div>
                        </div>
                        <div class="detail-car-appearance-content-photo" v-else>
                            <div class="loading">
                                <createQiniuImage :show-desc="true" :image="item.images[getIndex(index,names[index][0])]" :w="568" :h="392"></createQiniuImage>
                            </div>
                            <div class="loading excursion float-to-right">
                                <createQiniuImage :show-desc="true" :image="item.images[getIndex(index,names[index][1])]" :w="568" :h="392"></createQiniuImage>
                            </div>
                        </div>
                    </div>
            </div>`,
            data() {
                return {
                    datas: detailImages,
                    topBigImages:topBigImages,
                    names:[
                        ['外观-左前','外观-正前','外观-右前','外观-右正侧','外观-右后','外观-正后','外观-左后','外观-左正侧'],
                        ['内饰前排','主驾车门','中控台全部','车内顶棚','主驾驶安全带根部','主驾座椅-后背磨损','主驾座椅-底座磨损','内饰后排'],
                        ['漆膜仪检测','胎纹仪检测']
                    ]
                };
            },
            methods: {
                getIndex(index, name) {
                    let result = -1;
                    if (this.datas[index] && this.datas[index].images && this.datas[index].images.length !== 0) {
                        this.datas[index].images.forEach((image, index)=>{
                            if(image.imgageName === name) {
                                result = index;
                            }
                        })
                    }
                    return result;
                }
            }
        });
        new Vue({
            el: '.zhimai',
            template: '<app/>'
        });
    }

    // 点开的滑动大图初始化
    function initSlideImages(slideImages) {
        Vue.component('app', {
            template: `<div id="slider" class="owl-carousel"">
                <div class="item" rrc-event-name="detail_gallery" rrc-event-param="detail" v-for="item,index in datas">
                    <img :data-src="getImgUrl(item.imgUrl,870,580)" class="slider-image" :data-id="index" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
                     <p class="top-title-desc" v-if="item.title || item.desc">
                        <span class="title">{{$item.title}}</span>
                        <span class="desc" v-if="item.desc">:&nbsp;&nbsp;&nbsp;{{$item.desc}}</span>
                    </p>
                    <div class="pic-count">
                        <img class="profile" src="/dist/images/detail-version3-picCount-c3a14197.png">
                        <span class="current-index-large">1</span>
                        <span class="all-number-large">/{{datas.length}}</span>
                    </div>
                </div>
            </div>`,
            data() {
                return {
                    datas: slideImages
                };
            }
        });
        new Vue({
            el: '#slider',
            template: '<app/>'
        });
    }

    // carousel初始化
    function initCarousel(topBigImages) {
        Vue.component('app', {
            template: `<div id="carousel" class="owl-carousel" rrc-event-name="detail_gallery" rrc-event-param="detail">
               <div class="item" :data-id="index" v-for="item,index in topBigImages">
                <img :data-src="item.imgUrl" class="carousel-image" :data-id="index" />
                <p>{{index+1}}</p>
            </div>
            </div>`,
            data(){
                return {
                    topBigImages:topBigImages
                }
            }
        });
        new Vue({
            el: '#carousel',
            template: '<app/>'
        });
    }

    return {
        init(cb) {
            getImageBooks(cb);
        },
    };
});
